/* eslint-disable no-console */
import React from 'react';
import Chart from 'react-apexcharts';

const ApexBarChart = (props) => {
  const {barChartData, Recoverychange, isFeedComposition} = props;
  const value=[];
  const keys = [
    'CaCO3',
    'CaSO4',
    'BaSO4',
    'SrSO4',
    'CaF2',
    'Fe',
    'Mn',
    'Al',
    'SiO2',
    'CaHPO4',
    'MgOH2'
  ];
  const barKeys = barChartData.map(item => item.name).sort((a, b) => {
    return keys.indexOf(a) - keys.indexOf(b);
  });
  if(Recoverychange){
    barKeys.forEach(key => {
      const foundItem = barChartData.find(val => val.name === key);
      if (foundItem && foundItem.data !== undefined) {
        value.push(foundItem.data);
      } else {
        value.push(0);
      }
    });
  }

  const data = value;
  const options = {
    series: [
      {
        name: 'Saturation',
        data
      }
    ],
    chart: {
      type: 'bar',
      parentHeightOffset: 0,
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: '70%',
        // distributed: feedName ==='CLRO',
        dataLabels: {
          position: 'top' // top, center, bottom
        }
      }
    },
    noData: {
      text: 'No Data',
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '12px',
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
        colors: ['#333']
      },
      formatter (val) {
        if(Number(val).toFixed(0)==='0'){
          return '';
        }
        return `${Number(val).toFixed(1)  }`;
      },
      offsetY: -20
    },
    grid: {
      row: {
        colors: ['#fff', '#f2f2f2']
      }
    },
    legend: {
      show: false
    },
    xaxis: {
      labels: {
        rotate: -45
      },
      categories: barKeys,
      tickPlacement: 'on',
    },
    yaxis: {
      title: {
        text: '% Saturation'
      },
      min: 0,
      max: 140,
      tickAmount: 7,
      labels: {
        formatter (val) {
          // if(Number(val).toFixed(0)==='0'){
          //   return '';
          // }
          return `${Number(val).toFixed(1)  }`;
        },
      }
    },
    tooltip: {
      marker: {
        show: true,
      }
    },
    fill: {
      colors: [({ value})=> {
        if (value > 100) {
          return '#f34428';
        } if (value > 80 && value <= 100) {
          return '#FFBF00';
        }
        return '#8bc63e';
      }],

      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.15,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 0.76,
        opacityTo: 0.85,
        stops: [50, 0, 100],
        colorStops: []
      }
    }
  };
  return (
    <Chart options={options} series={options.series} type="bar" width="100%" height='280'/>
  );
};
export default ApexBarChart;